import m from 'mithril';
import {trans, has_permission} from "../helpers";
import SelectTypeahead from '../selectTypeaheadComponent.js';

import Steps from './steps.js';

let challenge_state = require('../new_challenge_creator/challengeState.js');


function get_groups() {
    m.request('/api/groups?part=items').then(d => {
        challenge_state.groups = d;

        challenge_state.groups.forEach(g => {
            if (!(g.code in challenge_state.search_exercises.groups)) {
                challenge_state.search_exercises.groups[g.code] = {
                    id_group: g.id_group*1,
                    list: []
                };
            }
        });

    }).catch(err => {
        alert('Something went wrong, please refresh page.')
    })
}

function get_group_items_ids() {
    let group_items = [];

    for (let key in challenge_state.search_exercises.groups) {
        let group = challenge_state.search_exercises.groups[key];

        for (let i in group.list)
            group_items.push(group.list[i]);
    }

    let group_item_ids = group_items.map(i => i.id_group_item*1);

    return group_item_ids;
}


class SelectExercise{
    oninit() {
        this.get_exercises();
        get_groups();
    }

    get_exercises(override=true) {
        if (override) {
            challenge_state.search_exercises.page = 1;
        }

        challenge_state.search_exercises.loading = true;
        challenge_state.search_exercises.load_more = false;

        m.redraw();

        let query_parameters = 'visibility=public' + 
                               '&page=' + challenge_state.search_exercises.page +
                               '&limit=' + challenge_state.search_exercises.limit +
                               '&visibility=public' +
                               '&order_by=inserted_at|desc' + 
                               '&part=sports' + 
                               '&query=' + challenge_state.search_exercises.query;

        let group_item_ids_str = get_group_items_ids().join(',');

        if (group_item_ids_str.length > 0) {
            query_parameters += '&group_item_ids=' + group_item_ids_str;
        }

        let sport_ids_str = challenge_state.search_exercises.sports.list.map(s => s.id_sport).join(',');

        if (sport_ids_str.length > 0) {
            query_parameters += '&sport_ids=' + sport_ids_str;
        }

        // put the selected exercises at the begining(json magic is for deep copy) 
        challenge_state.selected_exercises_to_show_first = JSON.parse(JSON.stringify(challenge_state.challenge.exercises)); 

        m.request('/api/exercises?' + query_parameters)
        .then(d => {
            if (d.length > challenge_state.search_exercises.limit) {
                challenge_state.search_exercises.load_more = true;
                d = d.slice(0, challenge_state.search_exercises.limit);
            }

            d = d.map(exercise => {
                exercise['id_exercise'] = exercise.id_exercise*1;
                exercise['inserted_at'] = new Date(exercise['inserted_at']).toLocaleDateString("sl-SI");

                return exercise;
            });            


            if (override) {
                challenge_state.exercises = d;                
            } else {
                challenge_state.exercises = challenge_state.exercises.concat(d);
            }

            challenge_state.search_exercises.loading = false;
        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
    }

    load_more(e) {
        challenge_state.search_exercises.page = challenge_state.search_exercises.page+1;
        challenge_state.search_exercises.load_more = false;
        this.get_exercises(false);
    }

    add_exercise(e) {
        challenge_state.current_step = 'create_exercise';
    }

    check_if_any_exercises_selected() {
        return challenge_state.challenge.exercises.length > 0;
    }

    goto_create_challenge(e) {
        let valid = this.check_if_any_exercises_selected();

        if (valid) {
            challenge_state.current_step = 'create_challenge';
        } else {
            // alert("You need to select at least 1 exercise, before you can continue");
            alert(trans('challenge.no_exercises_warning'));
        }
    }

    query_exercises(e) {
        challenge_state.search_exercises.query = e.target.value;

        clearTimeout(challenge_state.search_exercises.timeout);

        challenge_state.search_exercises.timeout = setTimeout(e => {
            challenge_state.search_exercises.page = 1;
            challenge_state.search_exercises.load_more = false;
            this.get_exercises();
        }, 500);
    }

    getSportsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&has_exercise=1&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    getSportTitle(sport) {
        return sport.title;
    }

    exercise_element(exercise) {
        let is_included = challenge_state.challenge.exercises.filter(e => e.id_exercise == exercise.id_exercise).length > 0;

        return m('div.item-component.item-component--selectable' + (is_included ? '.active' : ''), {
                onclick : e => {
                    if (is_included){
                        challenge_state.challenge.exercises = challenge_state.challenge.exercises.filter(e => e.id_exercise != exercise.id_exercise);
                        // let included_exercise = challenge_state.challenge.exercises.indexOf(exercise.id_exercise);
                        // if (included_exercise > -1) {
                        //     challenge_state.challenge.exercises.splice(included_exercise, 1);
                        // }
                    } else {
                        challenge_state.challenge.exercises = [];
                        // challenge_state.challenge.exercises.push(exercise.id_exercise*1);
                        challenge_state.challenge.exercises.push(exercise);
                    }
                }
            }, [
            exercise.url_poster &&
            m('div.item-component__thumb', 
                m('img', { src: exercise.url_poster })
            ),

            !exercise.url_poster &&
            m('div.item-component__thumb', 
                m('img', { src: '/imgs/default_thumb.jpg' })
            ),

            m('.item-component__info', [
                m('.item-component__title', exercise.title),
                // m('.item-component__author', [
                //     exercise.profile_picture_url &&
                //     m('.avatar', 
                //         m('img', { src: 'https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/' + exercise.profile_picture_url, alt: 'Profile image of ' + exercise.display_name  } )
                //     ),

                //     !exercise.profile_picture_url &&
                //     m('.avatar', 
                //         m('img', { src: 'https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/user_profile/default.jpg', alt: 'Profile image of ' + exercise.display_name })
                //     ),

                //     m('.item-component__author__name', exercise.display_name)
                // ]),
                m('small.item-component__author', [
                    exercise.short_description 
                ]),
                m('.item-component__author', [
                    m.trust(exercise.inserted_at) 
                ]),
            ])
        ]);
    }

    view() {
        let selected_exercises = challenge_state.challenge.exercises;

        let selected_exercises_titles = '';

        if (selected_exercises.length > 0)
            selected_exercises_titles = selected_exercises.map(e => e.title).join(', ');


        let selected_exercises_to_show_first = challenge_state.selected_exercises_to_show_first;
        let selected_exercises_ids = selected_exercises_to_show_first.map(e => e.id_exercise*1);

        let max_show_exercises = ((challenge_state.search_exercises.limit * challenge_state.search_exercises.page) - selected_exercises_to_show_first.length);

        let unselected_exercises = challenge_state.exercises.filter(e => !selected_exercises_ids.includes(e.id_exercise*1)).splice(0, max_show_exercises);

        return m('div', [
            m(Steps),

            // (challenge_state.loading_exercises && challenge_state.exercises.length == 0) &&
            // m('div', trans('challenge.loading')+'...'),

            m('h2.editor-title', [
                trans('challenge.select_exercise_title'),

                has_permission('exercises.create') &&
                [
                    ' ' + trans('common.or') + ' ',
                    m('.link', {
                        onclick: e => this.add_exercise(e)
                    }, trans('challenge.create_new_exercise_link_text').toLowerCase()),
                ]
            ]),

            m('.selected-exercises', [
                m('.selected-exercises__title', trans('challenge.selected_exercises') + ': '),
                
                (selected_exercises.length > 0) &&
                m('.selected-exercises__exercises', m('b', selected_exercises_titles)),
                
                (selected_exercises.length == 0 && !challenge_state.search_exercises.loading) &&
                m('.selected-exercises__exercises', m('b', trans('challenge.no_exercises_selected'))),
            ]),

            (challenge_state.challenge.exercises.length > 0) &&
            m('div.ijf-form', [
                m('div.line.line--center', [
                    m('div.btn.btn--full-width btn--main', {
                        onclick : e => { this.goto_create_challenge(e) }
                    }, trans('challenge.continue_btn'))
                ])
            ]),


            m('.component--filters', [
                m('.filters-row', [
                    m('.one-filter', [
                        m('.filter-label', trans('common.search')),
                        m('input', {
                            placeholder: trans('challenge.select_exercise_placeholder'),
                            type: 'text',
                            onkeyup: e => this.query_exercises(e)
                        })
                    ]),
                    
                    m('.one-filter', [
                        m('.filter-label', trans('common.sport')),
                        m(SelectTypeahead, {
                            listMode: false,
                            getData: this.getSportsData,
                            selectedItems: challenge_state.search_exercises.sports, // must be object with 'list' atribute (see function: get_groups())
                            placeholder: trans('common.all'),
                            noResultsText: trans('common.no_results'),
                            getItemText: this.getSportTitle,
                            getItemId: s => s.id_sport,
                            onChange: _ => this.get_exercises(true)
                        })
                    ]),
                    m('.one-filter', [
                        challenge_state.groups.map(g => {
                            return [
                                m('.filter-label', g.title),
                                challenge_state.search_exercises.groups[g.code] &&
                                m(SelectTypeahead, {
                                    listMode: true,
                                    list: g.items,
                                    selectedItems: challenge_state.search_exercises.groups[g.code], // must be object with 'list' atribute (see function: get_groups())
                                    placeholder: trans('common.all'),
                                    noResultsText: trans('common.no_results'),
                                    getItemText: i => i.title,
                                    getItemId: i => i.id_group_item,
                                    onChange: _ => this.get_exercises(true)
                                    // onClose: _ => get_data(true) // USE THIS TO GET DATA WHEN YOU CLOSE THE TYPEAHEAD
                                })
                            ]
                        })
                    ]),
                ]),

            ]),


            (challenge_state.exercises.length == 0 && !challenge_state.search_exercises.loading) &&
            m('.center-element', trans('common.no_results')),

            m('.exercise-selector', [
                (challenge_state.exercises.length > 0) &&
                m('.item-grid', [
                    selected_exercises_to_show_first.map(exercise => {
                        return this.exercise_element(exercise);
                    }),

                    unselected_exercises.map(exercise => {
                        return this.exercise_element(exercise);
                    })
                ]),

                (challenge_state.search_exercises.load_more && !challenge_state.search_exercises.loading) &&
                m('.btn btn--small.btn--full-width.btn-load-more', { 
                    onclick: e => this.load_more(e)
                }, trans('common.load_more')),

                challenge_state.search_exercises.loading &&
                m('.center-element.general-loader', ''),
                // m('div.center-element', trans('challenge.loading') + '...'),
            ]),

            (challenge_state.challenge.exercises.length > 0) &&
            m('div.ijf-form', [
                m('div.line.line--center', [
                    m('div.btn.btn--full-width btn--main', {
                        onclick : e => { this.goto_create_challenge(e) }
                    }, trans('challenge.continue_btn'))
                ])
            ])
        ])
    }
}

export default SelectExercise;